import React from "react";
import MUIDialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Slide from "@mui/material/Slide";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function Dialog(props) {
  const { showCloseButton = true } = props;

  return (
    <MUIDialog
      maxWidth={props.maxWidth ? props.maxWidth : "sm"}
      fullWidth={true}
      TransitionComponent={Transition}
      open={props.open}
      onClose={(e, reason) => {
        if (reason !== "backdropClick") {
          props.onClose();
        }
      }}
      PaperProps={{
        sx: {
          borderRadius: "12px",
          overflow: "hidden",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          py: 2,
          px: 3,
          borderBottom: "1px solid",
          borderColor: "divider",
          bgcolor: "grey.50",
        }}
      >
        <Box sx={{ fontWeight: 600, fontSize: "1.125rem" }}>{props.title}</Box>
        {showCloseButton && (
          <IconButton
            aria-label="close"
            onClick={props.onClose}
            size="small"
            sx={{
              color: "grey.500",
              "&:hover": {
                bgcolor: "grey.200",
                color: "grey.700",
              },
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        )}
      </DialogTitle>
      <DialogContent dividers sx={{ p: 3, border: "none" }}>{props.children}</DialogContent>
    </MUIDialog>
  );
}
